import React, { useState, useEffect } from 'react';
import FadeIn from './FadeIn';

const testimonialCategories = {
  "The Food & Catering": [
    {
      quote: "The food was incredible. Not 'good for a wedding'—genuinely restaurant quality. Our guests are still telling us it was the best meal they've ever had at a celebration.",
      author: "Sarah & Michael",
      location: "Los Angeles, CA"
    },
    {
      quote: "The culinary team accommodated our cultural menu requests flawlessly. The hors d'oeuvres on the terrace during sunset were an absolute highlight for everyone.",
      author: "David & Elena",
      location: "Pasadena, CA"
    }
  ],
  "The Venue & Flow": [
    {
      quote: "We toured so many venues that felt disjointed. Padua’s flow from the olive grove ceremony to the breathtaking historic ballroom felt incredibly natural and cohesive.",
      author: "Jessica & Ryan",
      location: "Orange County, CA"
    },
    {
      quote: "The sunset views from the terrace are cinematic. You completely escape the city, yet it was such an easy drive for our guests. The architecture alone is worth it.",
      author: "Amanda & Chris",
      location: "Rancho Cucamonga, CA"
    }
  ],
  "The Staff & Experience": [
    {
      quote: "The level of hospitality was unmatched. They handled every detail perfectly, allowing us to simply be present and enjoy the greatest day of our lives. True concierge service.",
      author: "Michelle & Joshua",
      location: "Claremont, CA"
    },
    {
      quote: "From our first private tour to the final sendoff, the communication was transparent and warm. We never felt like just another number; we felt like family.",
      author: "Lauren & DJ",
      location: "Upland, CA"
    }
  ]
};

const Testimonials = () => {
  const [activeCategory, setActiveCategory] = useState("The Venue & Flow");
  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    setCurrentIdx(0);
  }, [activeCategory]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIdx((prev) => (prev + 1) % testimonialCategories[activeCategory].length);
    }, 7000);
    return () => clearInterval(timer);
  }, [activeCategory]);

  return (
    <section className="py-32 md:py-40 bg-brand-charcoal text-brand-vintage relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://ik.imagekit.io/aeu02xvjgn/i-Wh5HSCQ-X3.jpg')] bg-cover bg-center opacity-10 mix-blend-overlay" />
      
      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
        <FadeIn className="mb-12">
          <span className="text-brand-bronze uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">
            Real Experiences
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-brand-vintage font-light mb-6">
            What Couples Actually Remember
          </h2>
          <div className="w-16 h-[1px] bg-brand-bronze mx-auto" />
        </FadeIn>

        {/* Category Tabs */}
        <FadeIn delay={0.1} className="flex flex-wrap justify-center gap-4 mb-16">
          {Object.keys(testimonialCategories).map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2 text-[10px] uppercase tracking-widest font-bold transition-all border ${
                activeCategory === category
                  ? 'border-brand-bronze bg-brand-bronze/20 text-brand-vintage'
                  : 'border-brand-vintage/20 text-brand-vintage/50 hover:border-brand-vintage/50 hover:text-brand-vintage'
              }`}
            >
              {category}
            </button>
          ))}
        </FadeIn>

        {/* Testimonial Display */}
        <FadeIn delay={0.2}>
          <div className="relative h-[320px] md:h-[220px] flex items-center justify-center mb-10">
            {testimonialCategories[activeCategory].map((test, idx) => (
              <div
                key={idx}
                className={`absolute inset-0 flex flex-col items-center justify-center transition-opacity duration-1000 ${
                  currentIdx === idx ? 'opacity-100 z-10' : 'opacity-0 z-0'
                }`}
              >
                <p className="font-serif text-2xl md:text-4xl leading-relaxed md:leading-[1.4] font-light text-brand-vintage/90 max-w-4xl mb-8">
                  "{test.quote}"
                </p>
                <div className="flex flex-col items-center">
                  <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-brand-bronze font-bold mb-1">
                    {test.author}
                  </span>
                  <span className="font-sans text-[9px] uppercase tracking-widest text-brand-vintage/40">
                    {test.location}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-3">
            {testimonialCategories[activeCategory].map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIdx(idx)}
                aria-label={`Show testimonial ${idx + 1}`}
                className={`w-2 h-2 rounded-full transition-all duration-500 ${
                  currentIdx === idx ? 'bg-brand-bronze w-6' : 'bg-brand-vintage/30'
                }`}
              />
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default Testimonials;